'use strict';
define([],function(){
    return {
        templateUrl: 'app/components/preview-mobile/preview-mobile.html',
        bindings: { src: '=' },
        controller:['$scope', function($scope) {


        }]
    };
});